export const environment = {
    production: false,
    apiUrl: 'https://lxview-dev.lxtech.com.br/api'
}